/** Risk rating section visibility (Angular loadApplicationDetail → showRiskRating). */
export function shouldShowRiskRatingSectionAngular(
  applicationAllData: Record<string, unknown>,
): boolean {
  const property = applicationAllData.property as { allow_dynamic_access_fee?: unknown } | undefined
  const allowDynamicAccessFee = property?.allow_dynamic_access_fee
  return allowDynamicAccessFee ? true : Boolean(applicationAllData.risk_rating)
}

/** Max rent icon red when max_rent < rent_amount (Angular). */
export function isMaxRentBelowAppliedRent(
  maxRent: unknown,
  rentAmount: unknown,
): boolean {
  return Number(maxRent ?? 0) < Number(rentAmount ?? 0)
}

/**
 * Screening Verified Income warning (Angular application-details.component.html):
 * `(value != null ? (value | number:'1.2-2') : '0') == '0'`
 *
 * Angular's number pipe formats an entered 0 as `"0.00"`, which is not equal to `'0'`,
 * so the warning only appears when the field is unset (null/undefined → fallback `'0'`).
 * Entering `$0.00` must clear the warning (CS-1135).
 */
export function shouldShowScreeningVerifiedIncomeWarning(
  underwriterVerifiedIncomeOther: unknown,
): boolean {
  return (
    underwriterVerifiedIncomeOther == null ||
    underwriterVerifiedIncomeOther === ''
  )
}
